import React from 'react';
import classes from './TextCell.module.css';

const TextCell = ({ value }) => {
  const text = String(value || '');

  return (
    <div className={classes.textCell}>
      {text}
    </div>
  );
};

export default TextCell;
